import React from "react";
import Table from "components/table";
import Button from "components/button/Button";
import useFeesTable from "./hooks/useFeesTable";
import ModalDeleteConfirmation from "components/modals/components/DeleteConfirmation";
import { IDynamicFees } from "./types/fees.interface";
import { useDisclosure } from "@chakra-ui/hooks";
import { createPortal } from "react-dom";
import { TiPlus } from "react-icons/ti";
import { Actions } from "constants/actions";
import DynamicFeeForm from "./components/DynamicFeeForm";
import FeesContext from "contexts/feesContext";

const DynamicFees = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { fees } = React.useContext(FeesContext);
  const { getDynamicFeesTableData, onDelete } = useFeesTable();
  const columnHeaders = [
    { name: "Nama" },
    { type: "Tipe" },
    { value: "Nominal" },
    { description: "Deskripsi" },
    { is_active: "Aktif" },
    { updated_at: "Diperbarui" },
    { actions: "Aksi" },
  ];
  const [action, setAction] = React.useState<Actions | null>(null);
  const [intendedItem, setIntendedItem] = React.useState<IDynamicFees | null>(
    null
  );

  const openModal = (props: IDynamicFees) => {
    onOpen();
    setIntendedItem(props);
  };

  const closeModal = () => {
    onClose();
    setIntendedItem(null);
  };

  React.useEffect(() => {
    getDynamicFeesTableData();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="mt-3 h-full">
      <Table
        hasHeader={true}
        tableTitle="Daftar Biaya Tambahan"
        tableData={fees}
        headerActions={
          <Button
            size="fit"
            variant="primary"
            children={
              <div className="flex items-center gap-1">
                <TiPlus /> Biaya Tambahan
              </div>
            }
            onClick={() => {
              setAction(Actions.CREATE);
              onOpen();
            }}
          />
        }
        columnHeaders={columnHeaders}
        handleUpdate={(data) => {
          setAction(Actions.UPDATE);
          openModal(data);
        }}
        handleDelete={(data) => {
          setAction(Actions.DELETE);
          openModal(data);
        }}
      />
      {createPortal(
        <DynamicFeeForm
          item={intendedItem}
          isOpen={isOpen && action !== Actions.DELETE}
          onClose={closeModal}
        />,
        document.body
      )}
      {createPortal(
        <ModalDeleteConfirmation
          isOpen={isOpen && action === Actions.DELETE}
          onClose={closeModal}
          onDelete={onDelete}
          itemName={intendedItem?.name}
          itemId={intendedItem?.id}
        />,
        document.body
      )}
    </div>
  );
};

export default DynamicFees;
